import './index.scss';
const Swiper = require('react-id-swiper').default;
import {inject, observer} from 'mobx-react';
import ModuleTitle from '../ModuleTitle';
@inject(({store}) => ({
    jump: store.jump,
    xtbk: store.xtbk
}))
@observer
class Hot extends React.Component {
    state = {
        activeIndex: 0
    }
    slideChange() {
        this.setState({
            activeIndex: this.swiper && this.swiper.realIndex
        });
    }

    render() {
        const {activeIndex} = this.state;
        const _this = this;
        const {jump, xtbk = []} = this.props;
        if(!xtbk.length || !xtbk.some(item => {
            return item && item.product.firstDestination;
        })) return null;
        return(
            <div className="m-hot m-floor" id="xtbkmk">
                <ModuleTitle name="xtbkmk"/>
                <div className="lists g-flexbox">
                    {
                        xtbk.map((item, index) => {
                            const {product} = item;
                            return (
                                <div className="list-item" key={index} onClick={() => {
                                    this.swiper && this.swiper.slideToLoop(index);
                                    clearTimeout(this.timer);
                                    this.timer = setTimeout(() => {
                                        this.swiper.autoplay.start();
                                    }, 1000);
                                }}>
                                    <div className="city">{item.shortTitle}</div>
                                    <div className="price">&yen;{product.taocanPrice || product.price}起</div>
                                </div>
                            );
                        })
                    }
                </div>
                <div className="slider">
                    <Swiper {
                        ...{
                            loop: true,
                            slidesPerView: 'auto',
                            centeredSlides: true,
                            spaceBetween: 12,
                            autoplay: {
                                delay: 5000
                            },
                            on: {
                                init: function() {
                                    _this.swiper = this;
                                },
                                slideChange: this.slideChange.bind(this),
                                click: (e) => {
                                    let node = e.target;
                                    while(!Array.from(node.classList).includes('swiper-item')) {
                                        node = node.parentNode;
                                    }
                                    try{
                                        jump(JSON.parse(node.getAttribute('data-info')));
                                        const pNode = node.parentNode;
                                        const posIdx = pNode.getAttribute('data-swiper-slide-index') || '-2';
                                        sendSK(`click_bk${parseInt(posIdx)+1}`);
                                    }catch(e) {}
                                }
                            }
                        }
                    }>
                        {xtbk.map((item, index) => {
                            const {product} = item;
                            return <div key={index} >
                                <div className="swiper-item" data-info={JSON.stringify(product.jumpInfo)}>
                                    <div className="cover">
                                        <img src={product.thumb}/>
                                        <div className="badge">{product.firstDestination} | {product.functionDisplay}</div>
                                    </div>
                                    <div className="title">{product.title}</div>
                                    <div className="b g-flexbox">
                                        <div className="price">&yen;<span>{product.taocanPrice || product.price}</span>起</div>
                                        <div className="btn-wrap">
                                            <div className="btn">抢购</div>
                                        </div>
                                    </div>
                                </div>
                            </div>;
                        })}
                    </Swiper>
                    <div className="dots g-flexbox">
                        {
                            xtbk.map((item, index) => {
                                return <div className={`dot-item ${index === activeIndex? 'active' : ''}`}></div>;
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default Hot;